import React, { useContext, useMemo, useState } from 'react'
import { UserContext, UserContextPayload } from '../../../../context/userContext';
import { progressInterface } from '../../../dashboard/contacts/createNewContactPopup';
import { Autocomplete, Divider, Grid, TextField, Typography } from '@mui/material'; 
import mappingStyles from "../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss"; 
import style from "../../../../assets/styles/componentStyles/feedbackStyles/feedbackStyle.module.scss";
import globalStyles from "../../../../assets/styles/global.module.scss";
import GlobalButton from '../../../utility/globalButton/button';
import uploadGif from "../../../../assets/images/campaignContact/upload.gif";
import { useProductStore } from '../../../../store/productStore';
import ProductCardTemplate from './productCardTemplate';
import { tertiaryColor } from '../../../../utils/colors';
import { productFields, requiredWhenWhatsAppCatalogFieldKeys, sortCatalogProductOptionalField } from './productConstant';
import Required from '../../../utility/required';
import axios from 'axios';
import { getFileTypeImgIcon } from '../../../../utils/constants';
import { uploadProductColumnMapping, uploadProductDataFromCSVPayload } from '../../../../models/axiosModel';
import agent from '../../../../services/api';
import CreateSingleProduct, { productFormField } from './createSingleProduct';
import { getVendorField } from '../../../../utils/whiteLabelling';
import { useShallow } from 'zustand/react/shallow';
import { useGenericStore } from '../../../../store/genericStore';

interface createProductPopupProps {
    getEComProductApiCall: () => Promise<void>,
    getWhatsAppCatalogsDataApiCall: () => Promise<void>,
    getCatalogProductOptionalFieldApiCall: () => Promise<void>
}

// const requiredProductField = 

const CreateProductPopup: React.FC<createProductPopupProps> = (props) => {
    
    const { getEComProductApiCall, getWhatsAppCatalogsDataApiCall, getCatalogProductOptionalFieldApiCall } = props;
    const innerHeight = window.innerHeight - 130;
    const innerHeightOfMapField = window.innerHeight - 300;

    const { setFlagLoading, flagLoading, handleError } = useContext(UserContext) as UserContextPayload;

    const { whatsAppCatalogsData, getWhatsAppCatalogsDataApi, catalogProductOptionalFieldData, getCatalogProductOptionalFieldApi, setFlagCreateProductPopup } = useProductStore(useShallow((state) => ({
        whatsAppCatalogsData: state.whatsAppCatalogsData,
        getWhatsAppCatalogsDataApi: state.getWhatsAppCatalogsDataApi,
        catalogProductOptionalFieldData: state.catalogProductOptionalFieldData,
        getCatalogProductOptionalFieldApi: state.getCatalogProductOptionalFieldApi,
        setFlagCreateProductPopup: state.setFlagCreateProductPopup
    })))

    const { showSuccess, showError } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess,
        showError: state.showError
    })))

    const [files, setFiles] = useState<any>([]);
    const [progress, setProgress] = useState<progressInterface>({ filename: "", percent: 0 });
    
    const [flagCreateProduct, setFlagCreateProduct] = useState<boolean>(true);
    const [flagCreateSingleProduct, setFlagCreateSingleProduct] = useState<boolean>(false); 
    const [flagMapTheField, setFlagMapTheField] = useState<boolean>(false);
    const [flagProcessingProduct, setFlagProcessingProduct] = useState<boolean>(false); 

    const [flagOnOkayClick, setFlagOnOkayClick] = useState<boolean>(false); 

    const [fieldsOfCSV, setFieldsOfCSV] = useState<string[]>([]);

    const [mappedProductFields, setMappedProductFields] = useState<(Map<string, string>)>(new Map());
    const [jsonProductArray, setJsonProductArray] = useState<any>(null);


    const uploadFileHandler = async (files: any[]) => { 
        const file: any = files[0];
        file.isUploading = true;
        setFiles([file]);

        let formData = new FormData()
        formData.append(
            "file", file, file.name,
        )
        formData.append("chatbot_flag", "true");

        let config = {
            onUploadProgress: (progressEvent: any) => {
                const { loaded, total } = progressEvent;
                var percent = Math.floor((loaded * 100) / total)
                setProgress({ ...progress, percent: percent, filename: file.name })
            }
        }

        setFlagLoading({ ...flagLoading, flagRoundLoader: true })
         try {
            const res = await agent.uploadFile.post(formData, config);

            if (res.status) {
                file.isUploading = false;
                file.file_data = res.data.data;
                file.google_storage_id = res.data.data.google_storage_id;

                await setFiles((old: any) => {
                    const temp = [...old];
                    const fileType = file.name.split('.').pop();
                    const fileTypeIconSrc = getFileTypeImgIcon(fileType) ?? "";
                    temp.map((rr: any) => {
                        if (rr.google_storage_id === file.google_storage_id) {
                            rr.isUploading = false;
                            rr.file_data = res.data.data;
                            rr.google_storage_id = res.data.data.google_storage_id;
                            rr.previewImageSrc = fileTypeIconSrc;
                        }
                    });
                    return temp;
                });

                return res.data.data.google_storage_id;
            }
        } catch (err) {
            showError("Something went wrong!")
            setFiles([]);
            console.error(err);
        } finally {
            setFlagLoading({ ...flagLoading, flagRoundLoader: false });
        }

        return undefined;
    }

    const onClickOfCreateSingleContact = () => {
        setFlagCreateProduct(false);
        setFlagCreateSingleProduct(true);
    }

    const checkDisableContinue = () => {
        for (let i = 0; i < visibleProductFields?.length; ++i){
            const currentField = visibleProductFields[i];
            if(currentField?.flag_required && mappedProductFields.get(currentField?.name) == ""){
                return true;
            }
        }
        return false;
    }   

    const importProductCsvFile = async (payload: uploadProductDataFromCSVPayload) => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true, }));
        setFlagProcessingProduct(true); 

        const res = await agent.uploadProductDataFromCSV.post(payload);
        if(res.status){
            showSuccess("Product Data have successfully imported.")
            getEComProductApiCall();
        } else {
            handleError(res);
        }
        setFlagCreateProductPopup(false);
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false, }));
    }

    const onClickOfContinueBtn = async () => {
        const storage_id = await uploadFileHandler(files);
        const columnMapping: Record<string, string> = {};
        visibleProductFields?.forEach((pField) => {
            columnMapping[pField?.key] = mappedProductFields.get(pField?.name) ?? '';
        })

        const payload: uploadProductDataFromCSVPayload = {
            storage_id: storage_id, 
            column_mapping: columnMapping,
        }
        await importProductCsvFile(payload);
    }

    const onClickOfContinueOfUploadCSVBtn = () => {
        for(let i = 0; i < visibleProductFields?.length; ++i){
            const data = visibleProductFields[i];
            const mappedFieldsOfCSV = fieldsOfCSV.find((field) => field === data.name);
            setMappedProductFields((prev) => {
                const updated = new Map(prev);
                updated.set(data.name, mappedFieldsOfCSV ? mappedFieldsOfCSV : '');
                return updated;
            });
        } 

        setFlagMapTheField(true);
    } 

    const handleChangeField = (newValue: string | null, fieldName: string) => {
        setMappedProductFields((prev) => {
            const updated = new Map(prev);
            updated.set(fieldName, newValue ?? '');
            return updated;
        });
    }

    const onClickOfCancelSingleProduct = () => {
        setFlagCreateProductPopup(false);
    } 

    const hasWhatsAppCatalogsData = (whatsAppCatalogsData?.length ?? 0) > 0;

    // has WhatsAppCatalogsData && mapped whatsApp Catalog column && and atleast one row have it's value. 
    const isWhatsAppCatalogColumnMapped = hasWhatsAppCatalogsData && Boolean(String(mappedProductFields.get("WhatsApp Catalog") ?? "").trim()) && jsonProductArray?.some((productData: any) => String(productData?.[mappedProductFields.get("WhatsApp Catalog") ?? '']).trim());

    const sortedCatalogOptionalFields = useMemo(() => {
        return sortCatalogProductOptionalField(catalogProductOptionalFieldData);
    }, [catalogProductOptionalFieldData]);

    const visibleProductFields = useMemo(() => {
        let updatedProductFields = productFields.filter((field) => {
            if(field?.key === 'flag_ecom_product_qr_code') return false;
            if (field?.key === "wa_catalog_id") return hasWhatsAppCatalogsData;
            if (field?.flag_show_when_whatsapp_catalog) return isWhatsAppCatalogColumnMapped
            return true;
        });
        updatedProductFields = updatedProductFields?.map((product) => {
            if(isWhatsAppCatalogColumnMapped && requiredWhenWhatsAppCatalogFieldKeys.includes(product?.key)){
                return {
                    ...product,
                    flag_required: true
                }
            }
            return product;
        })
        if(isWhatsAppCatalogColumnMapped){
            const wabaIdFieldObj = {
                name: "WhatsApp Business Account ID",
                key: "waba_id",
                getCallResponseKey: "waba_id",
                flag_required: true,
                flag_file_upload: false,
                flag_additional_info: false,
                field_placeholder: "",
                xs_value: 6,
            } 

            const productItemCatalogIndex = updatedProductFields.findIndex((field) => field?.key === "wa_catalog_id");

            if (productItemCatalogIndex === -1) {
                updatedProductFields = [...updatedProductFields, wabaIdFieldObj];
            }

            updatedProductFields = [...updatedProductFields.slice(0, productItemCatalogIndex + 1), wabaIdFieldObj, ...updatedProductFields.slice(productItemCatalogIndex + 1)];

            const optionalFieldsAsFormFields: productFormField[] = sortedCatalogOptionalFields.map((optionalField) => ({
                name: optionalField.field_name,
                key: optionalField.field_key,
                getCallResponseKey: optionalField.field_key,
                flag_required: false,
                flag_additional_info: false,
                field_placeholder: `Enter ${optionalField.field_name.toLowerCase()}`,
                xs_value: 6,
                isCatalogOptionalField: true,
                optionalField,
                flag_show_when_whatsapp_catalog: true
            }));

            const productItemGroupFieldIndex = updatedProductFields.findIndex((field) => field?.key === "ecom_product_item_group_id");

            if (productItemGroupFieldIndex === -1) {
                updatedProductFields = [...updatedProductFields, ...optionalFieldsAsFormFields];
            }

            updatedProductFields = [
                ...updatedProductFields.slice(0, productItemGroupFieldIndex + 1),
                ...optionalFieldsAsFormFields,
                ...updatedProductFields.slice(productItemGroupFieldIndex + 1),
            ];
        }

        for(let i = 0; i < updatedProductFields?.length; ++i) {
            const data = updatedProductFields[i];
            if(!mappedProductFields.get(data?.name)){
                const mappedFieldsOfCSV = fieldsOfCSV.find((field) => field === data.name);
                setMappedProductFields((prev) => {
                    const updated = new Map(prev);
                    updated.set(data.name, mappedFieldsOfCSV ? mappedFieldsOfCSV : '');
                    return updated;
                });
            }
        }
        return updatedProductFields;
    }, [hasWhatsAppCatalogsData, isWhatsAppCatalogColumnMapped, sortedCatalogOptionalFields]);

    return (
        <>
            <Grid container >
                <Grid item xs={12}>
                    <Grid container direction={"column"} justifyContent={"center"}>
                        <Grid item textAlign={"center"}>
                            <Typography className={mappingStyles.popupTitleTypography}> {flagCreateProduct ? "Add New Product" : flagCreateSingleProduct ? "Add a Single Product" : !flagMapTheField ? "Import Product (Upload CSV File)" : flagProcessingProduct ? "Import Products" : "Map The Fields"}</Typography>
                        </Grid>

                        <Divider className={mappingStyles.popupTitleDivider} />
                    
                        <Grid item className={`${globalStyles.fullwidth} ${flagCreateSingleProduct ? "" : globalStyles.overflowAuto}`} sx={flagCreateSingleProduct ? {} : {maxHeight: `${innerHeight}px !important`}}>
                            <Grid container className={mappingStyles.popupBodyGridContainer} gap={1}>
                                <Grid item xs={12}>
                                    {flagCreateProduct ? 
                                        <Grid container className={mappingStyles.createContactContainer}>
                                            <Grid item className={mappingStyles.createContactGridItem}>
                                                <Typography className={`${mappingStyles.contactOptionTypography} ${globalStyles.clickable}`} onClick={() => setFlagCreateProduct(false)}>Import Product (Upload CSV File)</Typography>
                                            </Grid>
                                            <Grid item className={mappingStyles.createContactGridItem}>
                                                <Typography className={`${mappingStyles.contactOptionTypography} ${globalStyles.clickable}`} onClick={() => onClickOfCreateSingleContact()}>Add a Single Product</Typography>
                                            </Grid>
                                        </Grid>
                                        : 
                                        flagCreateSingleProduct ? 
                                            <CreateSingleProduct
                                                getEComProductApiCall={getEComProductApiCall} 
                                                onClickOfCancel={onClickOfCancelSingleProduct}
                                                getWhatsAppCatalogsDataApiCall={getWhatsAppCatalogsDataApiCall}
                                                getCatalogProductOptionalFieldApiCall={getCatalogProductOptionalFieldApiCall}
                                            />
                                            : 
                                            !flagMapTheField ? 
                                                <ProductCardTemplate
                                                    files={files}
                                                    setFiles={setFiles} 
                                                    setFieldsOfCSV={setFieldsOfCSV}
                                                    onClickOfContinueOfUploadCSVBtn={onClickOfContinueOfUploadCSVBtn} 
                                                    jsonProductArray={jsonProductArray} 
                                                    setJsonProductArray={setJsonProductArray}
                                                />
                                                :
                                                flagProcessingProduct ? 
                                                    <Grid container textAlign={"center"} gap={"12px"} justifyContent={"center"} alignItems={"center"}>
                                                        <Grid item xs={12}>
                                                            <img src={uploadGif} alt="upload gif" height={"120px"} width={"120px"} />
                                                        </Grid>
                                                        <Grid item xs={9}>
                                                            <Typography sx={{ fontSize: "14px", fontWeight: "600", color: "#000000" }}>
                                                                Please wait while we process your products. It may take a few minutes to import all products.
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12} mt={2} mb={2}>
                                                            <GlobalButton
                                                                buttonText="Okay"
                                                                sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                                                className='primaryButtonStyle'
                                                                onClick={() => { setFlagOnOkayClick(true); setFlagCreateProductPopup(false); }}
                                                            >
                                                            </GlobalButton>
                                                        </Grid>
                                                    </Grid>
                                                    : 
                                                    <Grid container>
                                                        <Grid item xs={6} marginBottom={"10px"}>
                                                            <Typography sx={{ fontSize: "15px", fontWeight: "500", color: "#000" }}>Product List Fields</Typography>
                                                        </Grid>
                                                        <Grid item xs={6} marginBottom={"10px"}>
                                                            <Typography sx={{ fontSize: "15px", fontWeight: "500", color: "#000" }}>CSV Template Fields</Typography>
                                                        </Grid>

                                                        <Grid item xs={12} className={globalStyles.overflowAuto} sx={{ maxHeight: `${innerHeightOfMapField}px !important` }}> 
                                                            {visibleProductFields?.map((pField, ind: number) => {
                                                                return (    
                                                                    <Grid key={ind} container flexWrap={"nowrap"} alignItems={"center"} className={mappingStyles.mappingFieldsContainer}>
                                                                        <Grid item xs={6} sx={{ background: tertiaryColor, padding: "12.5px 7px", minHeight: "46px" }} className={mappingStyles.fieldsLabelStyle}>
                                                                            <Typography sx={{ fontSize: "14px", fontWeight: "500", color: "#000", display: "flex", alignItems: "center", justifyContent: "start", margin: "0", padding: "0 10px" }}>
                                                                                {pField?.name} {pField?.flag_required && <Required />}
                                                                            </Typography>
                                                                        </Grid> 
                                                                        <Grid item xs={6}>
                                                                            <Autocomplete
                                                                                options={fieldsOfCSV}
                                                                                // disableClearable
                                                                                value={mappedProductFields.get(pField?.name) ?? ''}
                                                                                getOptionLabel={(option) => option}
                                                                                renderInput={(params) => <TextField {...params} placeholder="Select" />}
                                                                                className={`${globalStyles.autocompleteParaphrasing} ${style.methodAutoComplete}`}
                                                                                sx={{ boxShadow: "none !important" }}
                                                                                onChange={(e, newValue) => { handleChangeField(newValue, pField?.name); }}
                                                                            />
                                                                        </Grid>
                                                                    </Grid>
                                                                );
                                                            })}
                                                        </Grid>

                                                        <Grid item xs={12} marginBlock={"15px"}>
                                                            <Grid container justifyContent={"center"} alignItems={"center"} gap={"12px"}>
                                                                <Grid item>
                                                                    <GlobalButton
                                                                        buttonText="Back"
                                                                        className='borderedButtonStyle'
                                                                        sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                                                        onClick={() => { setFlagMapTheField(false); }}
                                                                    >
                                                                    </GlobalButton>
                                                                </Grid>
                                                                <Grid item>
                                                                    <GlobalButton
                                                                        buttonText="Continue"
                                                                        sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                                                        className='primaryButtonStyle'
                                                                        disabled={checkDisableContinue()}
                                                                        onClick={() => { onClickOfContinueBtn() }}
                                                                    >
                                                                    </GlobalButton>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                    }
                                </Grid>
                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default CreateProductPopup
